// extracted by mini-css-extract-plugin
export default {"briefWrap":"brief_briefWrap__IFrAJ","iconBox":"brief_iconBox__+9KSF","icon":"brief_icon__uzCc2","armBand":"brief_armBand__inMD+","time":"brief_time__tWlcu"};